// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { mergeWithCss } from "@stoneage/XDL/Utilities";
import React from "react";
import { useState } from "react";

interface Props {
    unit: string;
    units: string[];
    onButtonClick: any;
    extendedStyles?: JettingAppUnitsToggleStyles;
}

export interface JettingAppUnitsToggleStyles {
    wrapper?: InjectableCss;
    button?: ClickablePresentationProps;
}

export const jettingAppUnitsToggleStyles: JettingAppUnitsToggleStyles = {};

const JettingAppUnitsToggle = ({ extendedStyles, onButtonClick, unit, units }: Props) => {
    const [styles] = useState(() => mergeWithCss(jettingAppUnitsToggleStyles, extendedStyles));

    const setSelectedUnit = (selectedUnit: string) => {
        if (unit !== selectedUnit) {
            onButtonClick(selectedUnit);
        }
    };
    if (!units) {
        return null;
    }
    return (
        <StyledWrapper {...styles.wrapper}>
            {units.map(u => {
                return (
                    <Clickable
                        {...styles.button}
                        onClick={() => setSelectedUnit(u)}
                        className={unit === u ? "selected" : ""}
                        disabled={unit === u}
                        key={u}
                        translate="no"
                    >
                        {u}
                    </Clickable>
                );
            })}
        </StyledWrapper>
    );
};
export default JettingAppUnitsToggle;
